// extracted by mini-css-extract-plugin
export default {"shift":"shift_shift__ldcU0","shiftSelectionCancelBtn":"shift_shiftSelectionCancelBtn__OMzZD","popupFooter":"shift_popupFooter__MUq6c"};